import { render, staticRenderFns } from "./NewOrderOverview.vue?vue&type=template&id=9380d03a&scoped=true&"
import script from "./NewOrderOverview.vue?vue&type=script&lang=ts&"
export * from "./NewOrderOverview.vue?vue&type=script&lang=ts&"
import style0 from "./NewOrderOverview.vue?vue&type=style&index=0&id=9380d03a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9380d03a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VDataTable,VIcon,VTooltip})
